import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { usersAPIUrls } from '../data';
import { RawUser, User } from '../types';
import { addDerivedUserData } from '../utils';

export type GetUser = {
  return: User;
};

export const getUser = withLogger(async (): Promise<User> => {
  const {
    data: { data: rawUser },
  } = await authServiceAxiosClient.get<{ success: boolean; data: RawUser }>(
    usersAPIUrls.userInfo,
  );
  const user = addDerivedUserData(rawUser);

  return user;
});
